import React from "react";
import ReactWOW from "react-wow";
import { $t } from '@/modules/i18n';
import { transformArray } from '@/utils/helper';



class Prizes extends React.Component {

  renderTutor(tutorList, row) {
    const len = (tutorList || []).length
    return (
      <div className="tutor-list">
        {
          tutorList.map((item, index) => {
            const desces = transformArray(item.desc)
            let isLeft = index * 2 < len
            if(row === 2 && index === 1) isLeft = false
            return (
              <div className={`tutor-item ${isLeft ? 'left' : 'right'}`} key={item.image}>
                <div className="tutor-image" style={{backgroundImage: `url(${item.image})`}}></div>
                <div className="tutor-desc">
                {
                  desces.map(desc => <p className="tutor-desc-p" key={desc} dangerouslySetInnerHTML={{ __html: desc}}></p>)
                }
                {
                  item.word && <p className="tutor-desc-word">{$t(item.word)}</p>
                }
                </div>
              </div>
            )
          })
        }
      </div>
    )
    
  }
  render() {
    const { message = {} } = this.props
    const iswraped = message.list[0] instanceof Array
    console.log(iswraped)
    return (
      <div className="tutor">
        <h2 className="section-title">{$t(message.title)}</h2>
        {/* <div className="tutor-list"> */}
        {
          iswraped ? 
            message.list.map((tutorList, index) => {
              return this.renderTutor(tutorList, index + 1)
            })
           : this.renderTutor(message.list)
        }
        {/* </div> */}
      </div>
    );
  }
}

export default Prizes;
